import React, { Fragment, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import {
  KeyboardTimePicker,
  KeyboardDatePicker
} from '@material-ui/pickers';

import {
  Box,
  Card,
  colors,
  Icon,
  Avatar,
  CardContent,
  CardHeader,
  Divider,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Button,
  Typography,
  DialogActions,
  Checkbox
} from '@material-ui/core';

import ChartDataLabels from 'chartjs-plugin-datalabels';

import {
  Chart as ChartJS,
  LineController,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LogarithmicScale,
  LineElement
} from 'chart.js';

ChartJS.register(
  PointElement,
  LineController,
  LineElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
  LogarithmicScale
);

import { Line } from 'react-chartjs-2';


import {
  Activity as ActivityIcon, AlignLeft
} from 'react-feather';

import SettingsInputSvideoIcon from '@material-ui/icons/SettingsInputSvideo';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  cardGraphic: {
  },
  graphic: {
    maxHeight: 540
  },
  abs: {

  },
  card: {

  },
  btnmonitor: {

  }
}));

const ColorCheckbox = withStyles({
  root: {
    marginLeft: 0,
    color: colors.blue[400],
    '&$checked': {
      color: colors.blue[500],
    }
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const defaultEndDateTime = new Date(moment().set({ hour: 23, minute: 59, seconds: 59 }));

const Activity = ({ open, equipment, usageItem, closeActivity, graphicData, changeGraphic, fields }) => {

  const classes = useStyles();

  const [startDateTime, setStartDateTime] = useState(new Date(moment().subtract(60, 'minutes')));
  const [endDateTime, setEndDateTime] = useState(defaultEndDateTime);

  var options = {
    resizeDelay: 300,
    indexAxis: 'x',
    elements: {
    },
    plugins: {
      datalabels: {
        anchor: "center",
        offset: 10,
        align: "center",
        display: false
      },
      legend: {
        display: true,
      }
    },
    scales: {
    }
  };

  const changeStartDatetime = (value) => {
    setStartDateTime(value);
    changeGraphic(fields, value, endDateTime)
  }

  const changeEndDatetime = (value) => {
    setEndDateTime(value);
    changeGraphic(fields, startDateTime, value)
  }

  const changeField = (fieldList, value) => {
    fields = [];
    fieldList.forEach(element => {
      if (value.unit == element.unit) {
        fields.push(element);
      }
    });
    changeGraphic(fields, startDateTime, endDateTime)
  }

  const isOnline = (event, device) => {
    if (event && device) {
      var dt = moment(event.createdAt);
      var now = moment();
      var dur = moment.duration(now.diff(dt)).as("minutes");
      return (dur < ((device.frequency) ? device.frequency : 0) + ((device.timeOut) ? device.timeOut : 0));
    } else {
      return 0;
    }
  }

  return (
    <Fragment>

      <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth>
        <DialogTitle id="form-dialog-title">
          <Typography
            color="textPrimary"
            variant="h4">
            Atividade do Equipamento
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box mt={1}>

            <Grid
              container
              className={classes.root}
              spacing={2}
              xs="auto"
            >
              <Grid
                item
                md={2}
                xs={12}
              >
                <Card className={classes.card} >

                  <CardHeader variant="h6" maxWidth={100}
                    avatar={
                      <Avatar style={{ backgroundColor: colors.grey[200] }}>
                        <Icon component={SettingsInputSvideoIcon} style={{ color: colors.blue[400] }}  ></Icon>
                      </Avatar>
                    }
                    title="Entradas Monitoradas"
                  />

                  <Divider></Divider>

                  <CardContent  >
                    <Grid
                      container
                      spacing={1}
                      justify="flex-start">

                      {usageItem.message.inputs.map((value) => (
                        (value.tests.length > 0) ? (
                          <Fragment>

                            <Grid
                              item
                              md={2}
                              xs={2}>
                              <ColorCheckbox />
                            </Grid>

                            <Grid
                              item
                              md={10}
                              xs={10}>

                              <Button color="secondary" fullWidth sx={{ marginRight: 1 }}
                                className={classes.btnmonitor}
                                startIcon={
                                  <Icon component={SettingsInputSvideoIcon} style={{ color: colors.blue[400] }} >
                                  </Icon>
                                }
                                size="medium"
                                variant="outlined"
                                onClick={() => { changeField(usageItem.message.inputs, value) }}
                              >
                                {value.name}
                              </Button>
                            </Grid>

                          </Fragment>

                        ) : (
                          ""
                        )
                      ))}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid
                item
                md={10}
                xs={12}
              >

                <Card className={classes.cardGraphic}>

                  {isOnline(usageItem.event, usageItem.device) ?
                    (<CardHeader

                      action={(
                        <Button
                          endIcon={<ArrowDropDownIcon />}
                          size="small"
                          variant="text"
                        >
                          {(graphicData.datasets[0]) ? graphicData.datasets[0].data.length : 0} Amostras
                        </Button>
                      )}

                      avatar={
                        <Avatar style={{ color: colors.blue[400], backgroundColor: colors.green[600] }}  >
                          <Icon component={ActivityIcon} style={{ color: 'white' }}  ></Icon>
                        </Avatar>
                      }
                      title={`Estado atualizado em ` + moment(usageItem.event.createdAt).format('DD/MM/YYYY')}
                      subheader={<b><b>{moment(usageItem.event.createdAt).format('HH:mm:ss')} </b> <b style={{ color: colors.green[600] }}> {`( DISPOSITIVO CONECTADO )`} </b></b>}
                    />)
                    :
                    (<CardHeader

                      action={(
                        <Button
                          endIcon={<ArrowDropDownIcon />}
                          size="small"
                          variant="text"
                        >
                          {(graphicData.datasets[0]) ? graphicData.datasets[0].data.length : 0} Amostras
                        </Button>
                      )}

                      avatar={
                        <Avatar style={{ color: colors.blue[400], backgroundColor: colors.red[600] }}  >
                          <Icon component={ActivityIcon} style={{ color: 'white' }}  ></Icon>
                        </Avatar>
                      }
                      title={`Estado atualizado em ` + moment(usageItem.event.createdAt).format('DD/MM/YYYY')}
                      subheader={<b><b>{moment(usageItem.event.createdAt).format('HH:mm:ss')} </b> <b style={{ color: colors.red[600] }}> {`( DISPOSITIVO DESCONECTADO )`} </b></b>}
                    />)
                  }

                  <Divider></Divider>

                  <CardContent className={classes.abs}>
                    <Box>

                      <Grid container alignContent='flex-start' justify="flex-start" spacing={2}>

                        <Grid item
                          md={2}
                          xs={12}>
                          <KeyboardDatePicker
                            margin="normal"
                            cancelLabel="Cancelar"
                            id="date-picker-dialog1"
                            label="Data Inicial"
                            format="DD/MM/YYYY"
                            value={startDateTime}
                            inputVariant="outlined"
                            onChange={changeStartDatetime}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>

                        <Grid item
                          md={2}
                          xs={12}>

                          <KeyboardTimePicker
                            margin="normal"
                            cancelLabel="Cancelar"
                            id="time-picker1"
                            format="HH:mm"
                            label="Hora Inicial"
                            value={startDateTime}
                            inputVariant="outlined"
                            onChange={changeStartDatetime}
                            KeyboardButtonProps={{
                              'aria-label': 'change time',
                            }}
                          />
                        </Grid>

                        <Grid item
                          md={2}
                          xs={12}>

                          <KeyboardDatePicker
                            cancelLabel="Cancelar"
                            margin="normal"
                            id="date-picker-dialog2"
                            label="Data Final"
                            format="DD/MM/YYYY"
                            value={endDateTime}
                            inputVariant="outlined"
                            onChange={changeEndDatetime}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>

                        <Grid item
                          md={2}
                          xs={12}>

                          <KeyboardTimePicker
                            margin="normal"
                            cancelLabel="Cancelar"
                            id="time-picker2"
                            format="HH:mm"
                            label="Hora Final"
                            value={endDateTime}
                            inputVariant="outlined"
                            onChange={changeEndDatetime}
                            KeyboardButtonProps={{
                              'aria-label': 'change time',
                            }}
                          />
                        </Grid>

                        <Grid item
                          md={12}
                          xs={12}>
                          <Line data={graphicData} options={options} className={classes.graphic} />
                        </Grid>

                      </Grid>

                    </Box>

                  </CardContent>

                </Card>

              </Grid>

            </Grid>

          </Box>

        </DialogContent>

        <Divider />

        <DialogActions>
          <Grid container
            direction="row"
            justify="flex-end"
            alignItems="center"
            spacing={2}  >
            <Grid item >
              <Button
                color="secondary"
                size="small"
                variant="contained"
                onClick={() => { closeActivity(equipment) }}>
                Fechar
              </Button>
            </Grid>
          </Grid>
        </DialogActions>

      </Dialog>

    </Fragment>

  );
};

export default Activity;
